import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as person from '../check-in'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: person.RESOURCE.payload.dimension.partialId,
      partialId: person.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Snapshot,
    }),
    description: 'Prompt given to the employee for the check-in',
    isOptional: true,
    name: 'Prompt',
    partialId: PartialId.Standard.create('prompt'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
